import { createFileRoute } from '@tanstack/react-router'
import { AppHeader } from '@/shared/components/layout/AppHeader'
import { PreferencesControl } from '@/shared/components/layout/PreferencesControl'
import { AccountTabs } from '@/features/profile/components/AccountTabs'
import { useTranslation } from '@/shared/i18n/useTranslation'
import styles from './preferences.module.css'

export const Route = createFileRoute('/_authenticated/preferences')({
  component: PreferencesPage,
})

function PreferencesPage() {
  const { t } = useTranslation()

  return (
    <>
      <AppHeader title={t('prefs.title')} />
      <div className={styles.page}>
        <AccountTabs />
        <PreferencesControl className={styles.control} />
      </div>
    </>
  )
}
